import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { DataGrid, esES } from '@mui/x-data-grid';
import { LinearProgress, Typography } from '@mui/material';
import { setDashboardNodeSelected } from '../../store/fuse/dashboard';

const columns = [
  {
    field: 'dsnodo',
    headerName: 'Nodo',
    width: 250,
    flex: 1,
  },
  {
    field: 'dsinterface',
    headerName: 'Interfaz',
    // width: 250,
    // editable: true,
    flex: 1,
  },
  {
    field: 'dslectura1',
    headerName: 'Ancho de Banda Entrada',
    description: 'Valores RX',
    sortable: true,
    flex: 1,
    align: 'left',
    renderCell: (params) => {
      // const [progressBarColor, progressBarLabelColor] = setProgressBarColor(params.row?.inMaxBps, 'bandwidth');
      const bandwidthIn = Number(params.row?.inMaxBps) / 1000000;
      return (
        <Box display="flex" flexDirection="row" alignItems="center" sx={{ width: '100%' }}>
          <Typography variant="body2">{`${bandwidthIn.toFixed(3)} Mbps`}</Typography>
        </Box>
      );
    },
  },
  {
    field: 'dslectura2',
    headerName: 'Ancho de Banda Salida',
    description: 'Valores TX',
    sortable: true,
    flex: 1,
    renderCell: (params) => {
      // const [progressBarColor, progressBarLabelColor] = setProgressBarColor(params.row?.outMaxBps, 'bandwidth');
      const bandwidthOut = Number(params.row?.outMaxBps) / 1000000;
      return (
        <Box display="flex" flexDirection="row" alignItems="center" sx={{ width: '100%' }}>
          <Typography variant="body2">{`${bandwidthOut.toFixed(3)} Mbps`}</Typography>
        </Box>
      );
    },
  },
];

const TopInterfaces = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const topInterfacesData = useSelector((state) => state?.fuse?.dashboard?.dashboard?.topInterfaces);

  const handleRowClick = (row) => {
    dispatch(setDashboardNodeSelected('/dashboard', row.row.dsnodo));
    navigate(`/dashboard/${row.row.nodeid}`);
  };

  return (
    <div style={{ width: '70%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
      <strong className="title-chart">Top 10 Nodos por Porcentaje de Utilización</strong>
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: 580, width: '100%', marginTop: '20px' }}>
        <DataGrid
          localeText={{
            ...esES.components.MuiDataGrid.defaultProps.localeText,
            noRowsLabel: 'No hay interfaces', // You can customize this string
          }}
          rows={topInterfacesData}
          columns={columns}
          disableRowSelectionOnClick
          hideFooter
          onRowClick={handleRowClick}
        />
      </Box>
    </div>
  );
};

export default TopInterfaces;
